import { Tooltip as MantineTooltip, type TooltipFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./tooltip.module.scss";
import type { IProps } from "./tooltip.types";
import { TOOLTIP_DEFAULT_DELAY } from "./tooltip.constants";
import "../../inverted.scss";

/**
 * Tooltip component, on the inverted Neutral/90 background.
 * @param {boolean} props.delayOpen - Waits the default delay before opening.
 * @param {boolean} props.inverted - Gives text inside the Text/Inverse colours. Defaults to true.
 * @returns {JSX.Element} The Tooltip component.
 */
const Tooltip = componentWrapper<TooltipFactory, IProps>(
    "Tooltip",
    ({ delayOpen = false, inverted = true, ...props }, ref) => {
        return (
            <MantineTooltip
                p="md"
                bdrs="md"
                maw={540}
                multiline
                withArrow
                arrowSize={9}
                ref={ref}
                classNames={{ tooltip: styles["container"] }}
                openDelay={delayOpen ? TOOLTIP_DEFAULT_DELAY : 0}
                data-inverted={inverted}
                {...props}
            />
        );
    }
);

Tooltip.Floating = MantineTooltip.Floating;
Tooltip.Group = MantineTooltip.Group;

export { Tooltip };
